import React from 'react';
import { launchAsync } from '@microsoft/immersive-reader-sdk';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  immersive_reader: {
    id: 'immersive_reader',
    defaultMessage: 'Lettura facilitata',
  },
});

const ImmersiveReader = ({
  tokenURL = '/++api++/@immersive-reader-token',
  title,
  getText,
  options = { uiZIndex: 2000 },
  buttonText,
}) => {
  const intl = useIntl();
  const getTokenandLaunch = () => {
    fetch(tokenURL, {
      credentials: `include`,
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((body) => {
        const data = {
          title: title,
          locale: intl.locale,
          chunks: [
            {
              content: getText(),
              mimeType: 'text/html',
              locale: intl.locale,
            },
          ],
        };

        launchAsync(body.token, body.subdomain, data, options).catch(function (
          error: any,
        ) {
          alert('Impossibile caricare Immersive Reader.');
          console.log(error);
        });
      })
      .catch((error) => {
        alert('2 - Impossibile caricare Immersive Reader.');
        console.error('Error:', error);
      });
  };

  return (
    <div className="immersive-reader-wrapper-button">
      <button
        className="immersive-reader-launch-button btn btn-link btn-icon px-0"
        onClick={() => getTokenandLaunch()}
      >
        {buttonText ?? intl.formatMessage(messages.immersive_reader)}
        <img
          src="https://contentstorage.onenote.office.net/onenoteltir/permanent-static-resources/immersive-reader-icon.svg"
          alt=""
          className="icon ms-1"
          aria-hidden="true"
        />
      </button>
    </div>
  );
};

export default ImmersiveReader;
